// extracted by mini-css-extract-plugin
export default {"quiz":"Quiz_quiz__WVcdD","quizContent":"Quiz_quizContent__Aubpx","quizBg":"Quiz_quizBg__CdJv5","quizBg__elem":"Quiz_quizBg__elem__k1E4g"};